(function() {
    'use strict';
    var controllerId = 'vendorListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams',  '$window', VendorListCtrl]);

    function VendorListCtrl(common, datacontext, $scope, $location, NgTableParams, $window) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.title = 'Vendor List View';
        $scope.IsHidden = true;

            $scope.ShowHide = function (vendor_id,vendor_name,cnt_avail,check) {
                //If DIV is hidden it will be visible and vice versa.
                $scope.vendor_id = vendor_id;
                $scope.vendor_name = vendor_name;
                $scope.cnt_avail = cnt_avail;
                $scope.IsHidden = $scope.IsHidden ? false : true;
                $scope.check = check;

                if($scope.check == 1){
                datacontext.get_audit_vendor({vendor_id : vendor_id}).then(function(res) {
                	$scope.IsHidden = false;
                    $scope.count = res.data;
                 });
                }else{
                    $scope.count = 0;
                }

            }
        vm.query = {
            queryType:'array-count',
            order_by:'vendor_name',
            order_dir:'asc',
            page:1,
            limit:50
        };

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }

            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
        	if(vm.grid !== 0){
        		vm.grid = 0;
        		return "";
        	}
            for ( var i in newValue ) {
                if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_vendors();
                }
            }
            vm.grid = 0;
        });

        activate();

        function activate() {
            var promises = [
                get_vendors(),
                get_stores()
            ];

            common.activateController(promises, controllerId)
                .then(function() {
                    //log('Activated ' + vm.title);
                });
        }

        $scope.create_vendor = function() {
            datacontext.create_vendor({vendor_name : "new vendor"}).then(function(res) {
                var new_vendor_id = res.data.data;
                console.log("new_vendor_id",new_vendor_id);
                $location.path('/vendors/' + new_vendor_id );
            });
        };

        $scope.audit_vendor = function(vendor_id,vendor_name) {
        		 datacontext.audit_vendor({vendor_id : vendor_id}).then(function(res) {
        			 console.log("yes");
                     log('Products to be audited are updated');
                     $location.path('/vendors/');
                     $scope.IsHidden = true;
                 });
        };

        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }

        function get_vendors() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;


                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_vendors(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }

        $scope.search = function(store_id,include_store) {
          vm.query = {
              queryType:'array-count',
              order_by:'vendor_name',
              order_dir:'asc',
              store_id: store_id,
              include_store:include_store,
              page:1,
              limit:50
          };
          vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;


                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_vendors(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
          // console.log(vm.query);
          // return datacontext.get_vendors(vm.query).then(function (httpResult) {
          //     params.total(httpResult.data.total);
          //     vm.results_total = httpResult.data.total;
          //     vm.query.page = params.page;
          //     // set new data
          //     vm.results = httpResult.data.data;
          //     vm.grid = 1;
          //     return httpResult.data.data;
          // });
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'VendorInventoryController';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', VendorInventoryController]);

    function VendorInventoryController(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.title = 'Vendor List View';

        activate();

        function activate() {
            var promises = [
                get_vendor()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    log('Activated ' + vm.title);
                });
        }

        function get_vendor() {
            return datacontext.get_vendors_v1().then(function(httpResult) {
                vm.vendor = httpResult.data;
            });
        }
    }
})();

(function() {
    'use strict';
    var controllerId = 'vendorDetailCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', vendorDetailCtrl]);

    function vendorDetailCtrl(common, datacontext, $scope, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.orders = [];
        vm.title = 'Vendor Detail View';

        $scope.vendor_id = $routeParams.vid;

        vm.updateSubmitting = 0;
        vm.updateSuccess = 0;
        vm.updateError = 0;

        // setting for audit log
        $scope.audit_link_id = $routeParams.vid;
        $scope.audit_type_id = 7;

        $scope.active_stores = [];

        activate();

        function activate() {
            var promises = [
                get_vendor(),
                get_vendor_auth_stores()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    //log('Activated ' + vm.title);
                });
        }

        function get_vendor() {
            return datacontext.get_vendors_v1({vendor_id:$scope.vendor_id}).then(function(httpResult) {
                $scope.vendor = httpResult.data.data[0];
            });
        }

        function get_vendor_auth_stores() {
            return datacontext.get_vendor_auth_stores({vendor_id:$scope.vendor_id}).then(function(httpResult) {
                $scope.store_vendors = httpResult.data.data;
                $scope.store_vendors_list = httpResult.data.STORESLIST;

                angular.forEach(httpResult.data.data, function(value) {
                	console.log(value.store_id , $scope.store_vendors_list.indexOf(value.store_id));
                	if ( value.is_active) {
                        $scope.active_stores.push(value.store_id);
                    }else{


                    	if ($scope.store_vendors_list.indexOf(value.store_id) != -1){
                    		$scope.active_stores.push(value.store_id);
                    	}
                    }
                });
                $scope.current_stores = angular.copy($scope.active_stores);
            });
        }


        $scope.update_vendor = function(data) {

            vm.updateSubmitting = 1;
            vm.updateSuccess = 0;

            var new_stores = angular.copy($scope.active_stores);
            var del_stores = [];

            angular.forEach( $scope.current_stores, function(prev_store_id) {
                var action = 'delete';
                var count = 0;

                angular.forEach( $scope.active_stores, function(active_store_id) {
                    if (prev_store_id === active_store_id) {

                        action = 'match';
                        // not change remove from new_store_array
                        new_stores.splice(count, 1);
                    }
                });

                count ++;

                if ( action === 'delete') {
                    del_stores.push(prev_store_id);
                }
            });

            console.log("current_stores", $scope.current_stores);
            console.log("active_stores", $scope.active_stores);
            console.log("del_stores", del_stores);
            console.log("new_stores", new_stores);

            angular.forEach(del_stores, function(store_id) {
                datacontext.delete_vendor_auth_stores({store_id:store_id,vendor_id:$scope.vendor_id}).then(function() {});
             });

             angular.forEach(new_stores, function(store_id) {
                 datacontext.create_vendor_auth_stores({store_id:store_id,vendor_id:$scope.vendor_id}).then(function() {});
             });

            // prevent updating other data in scope
            var payload = {
                vendor_id : data.vendor_id,
                vendor_name : data.vendor_name,
                lead_time: data.lead_time,
                note: data.note
            };

            datacontext.update_vendor(payload).then(function() {
                vm.updateSubmitting = 0;
                vm.updateSuccess = 1;

                // Pass
                get_vendor();
                get_vendor_auth_stores();

                $scope.$broadcast('refreshAuditLog', 'refresh');


            });
        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'manufacturerListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modal', 'NgTableParams',  '$window', manufacturerListCtrl]);

    function manufacturerListCtrl(common, datacontext, $scope, $location, $modal, NgTableParams, $window) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.title = 'Manufacturer List View';

        vm.query = {
            queryType:'array-count',
            order_by:'manufacturer_name',
            order_dir:'asc',
            page:1,
            limit:20
        };

        vm.urlQuery  = $location.search();
        vm.url_used = 0;

        // loop and set url var
        for (var i in vm.urlQuery) {
            // ignore query type in url
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }

            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            vm.url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
        	if(vm.grid !== 0){
        		vm.grid = 0;
        		return "";
        	}
            for ( var i in newValue ) {
                if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_manufacturers();
                }
            }
            vm.grid = 0;
        });

        activate();

        function activate() {
            var promises = [
                get_manufacturers()
            ];

            common.activateController(promises, controllerId)
                .then(function() {
                    //log('Activated ' + vm.title);
                });
        }

        function get_manufacturers() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;


                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_manufacturer_report(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }

        $scope.create_manuf = function () {
            // merge order item w/order items
            vm.query = {
	                manufacturer_name:''
	            };
            var modalInstance = $modal.open({
                templateUrl: '/app/vendors/partials/manuf_modal.html',
                controller: 'manufModalCtrl',
                resolve: {

                }
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'manufModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modalInstance', 'NgTableParams',  '$window', manufModalCtrl]);

    function manufModalCtrl(common, datacontext, $scope, $location, $modalInstance, NgTableParams, $window) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.title = 'Manufacturer List View';

        vm.query = {
            queryType:'array-count',
            order_by:'manufacturer_name',
            order_dir:'asc',
            page:1,
            limit:20
        };

        $scope.createManuf = function (name) {

            var formData = {
                manufacturer_name: name
            };
            console.log(formData);
            datacontext.create_manufacturer(formData).then(function (httpResult) {
            	console.log(httpResult);
            	$modalInstance.close('update');
            });

        };



    }
})();
